import { createSelector } from '@reduxjs/toolkit';
import uniq from 'lodash/uniq';
import { alphaSort } from 'vet-bones/utils';

import { ClassRelationshipItem } from 'src/containers/ProjectDiagram/components/classDrawer/types';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import { projectLinkDataArraySelector } from 'src/selectors/projectLinkDataArray';
import * as copy from 'src/templates/copy';

export const projectRelationshipItemsSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectLabelsByIriSelector(projectId),
      projectLinkDataArraySelector(projectId),
      (labelsByIri, linkDataArray) =>
        uniq(
          linkDataArray
            .filter((data) => isModelConceptRelationship(data))
            .map((data) => data.value)
        )
          .map<ClassRelationshipItem>((iri) => ({
            text: getLabelForIri(
              labelsByIri,
              iri,
              copy.components.projectDiagram.modelConceptRelationship.new
            ),
            value: iri,
            directions: [],
          }))
          .sort(alphaSort((item) => item.text))
    )
);
